module.exports = __webpack_public_path__ + "img/task-7-l.9ceb7a2f.png";